import List from 'list.js';

document.addEventListener("turbolinks:load", function() {
  let items_selector = document.querySelector('#sort-items')
  if (items_selector){

    let items = items_selector.querySelectorAll('[data-sort]')
    let valueNames = [...items].map(item => item.dataset['sort'])

    if(valueNames) {
      var options = {
        valueNames: valueNames,
        page: 30,
        pagination: true
      }
      new List('sortable', options);
    }

  }

})
